const initialState = {
  companyForm: "",
  companyFormYear1: "",
  companyFormYear2: "",
  companyFormYear3: "",
};
const ActiveCompanyFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case "TOGGLE_COMPANY_FORM":
      return { ...state, companyForm: action.payload };
    case "TOGGLE_COMPANY_FORM_YEAR1":
      return { ...state, companyFormYear1: action.payload };
    case "TOGGLE_COMPANY_FORM_YEAR2":
      return { ...state, companyFormYear2: action.payload };
    case "TOGGLE_COMPANY_FORM_YEAR3":
      return { ...state, companyFormYear3: action.payload };

    default:
      return state;
  }
};

export default ActiveCompanyFormReducer;
